import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Center, Tooltip,
} from '@mantine/core';

export default function useColImportantSchema() {
    const colDeleteSchema = {
        accessor: 'is_important',
        style: {
            padding: '0.625rem 0.1rem 0.625rem 0.1rem',
            width: '30px',
        },
        title: (
            <Center>
                <FontAwesomeIcon icon="exclamation" />
            </Center>
        ),
        render: ({ row }) => row.is_important && (
            <Tooltip label="Приоритетный баннер">

                <Center>
                    <FontAwesomeIcon icon="exclamation" />
                </Center>
            </Tooltip>
        ),
    };

    return colDeleteSchema;
}
